<ion-card>
  <ion-row>
    <ion-col size="12" sizeMd="12" class="padding5">
      <div class="font1_2 padding5 bold">{{questions.header.title}}</div>
      <div class="padding5">{{questions.header.description}}
      </div>
    </ion-col>
    <ion-card *ngFor="let q of questions.questions">
      <ion-col class="margin5px" size="12" sizeMd="12" *ngIf="q.type === 'multi'">
        <div class="font1_2 padding5">{{q.id}}. {{ q.text }}</div>
        <div class="option-row" *ngFor="let opt of q.options">
          <ion-checkbox (ionChange)="updateAnswer(q.id, opt, $event.detail.checked)">
          </ion-checkbox>
          <span class="padding5"> {{ opt }}</span>
        </div>
      </ion-col>
      <ion-col class="margin5px" size="12" *ngIf="q.type === 'text'">
        <div class="font1_2 padding5">{{q.id}}. {{ q.text }}</div>
        <app-a-textarea [label]="trans.translate('Your Answer')"
          (variableChange)="updateTextAnswer(q.id,q.text)"></app-a-textarea>
      </ion-col>
    </ion-card>
    <ion-col size="12" sizeMd="12">
      <span>{{'In case of emergency (e.g., blood donation), would you be willing to help?' | translate}}</span>
      <div class="padding10">
        <ion-checkbox [(ngModel)]="bloodDonation"></ion-checkbox>
        <span class="padding10">{{'Yes'|translate}}</span>
      </div>
    </ion-col>

    <ion-col size="12" sizeMd="6" class="padding5" *ngIf="bloodDonation">
      <app-a-select [label]="trans.translate('Blood Group')" [(variable)]="auth.loggedInEmployee.user.user_pd.blood"
        [objectList]="utilityService.bloodGroupList">
      </app-a-select>
    </ion-col>

  </ion-row>
</ion-card>